export default "__VITE_ASSET__DiJ0af2K__"